import React from 'react';
import PropTypes from 'prop-types';
import { ButtonArrowState, Modal, TertiaryButton } from '@huggg/react-components';
import NewTabLink from 'assets/img/icons/newTabLink.svg';
import styles from "./prepaidCard.module.scss";
import dictionary from 'config/dictionary';
import { VirtualCardRestrictionDiagram } from '../../../../../ui/PrepaidCard/VirtualCardRestrictionDiagram';

const CardRestrictionModal = ({ onClose, helpLinkToShow }) => {

  return (
    <Modal title={dictionary.prepaidCards.labels.howCanIUseThisCard} onClose={onClose} className={styles.cardRestrictionsModal}>
      <div className={styles.cardRestrictionsModalContent}>
        <p className={styles.semiBold}>{dictionary.prepaidCards.copy.usageHeader}</p>
        <VirtualCardRestrictionDiagram />
        <p>{dictionary.prepaidCards.copy.usageDescription}</p>
        <div>
          {helpLinkToShow === 'energy' && <a
            className={styles.externalLink}
            href={dictionary.prepaidCards.links.energyCardHelp}
            target="_blank"
            rel="noopener noreferrer"
          >
            {dictionary.prepaidCards.labels.energyCardHelpLabel}
            <img src={NewTabLink} alt="" />
          </a>}

          {helpLinkToShow === 'water' && <a

            className={styles.externalLink}
            href={dictionary.prepaidCards.links.waterCardHelp}
            target="_blank"
            rel="noopener noreferrer"
          >
            {dictionary.prepaidCards.labels.waterCardHelpLabel}
            <img src={NewTabLink} alt="" />
          </a>}
        </div>
        <TertiaryButton label={dictionary.prepaidCards.labels.closeThisWindow} onClick={onClose} arrow={ButtonArrowState.None} />
      </div>
    </Modal >
  );
};

CardRestrictionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CardRestrictionModal;
